<template>
  <div style="margin-bottom: 10px;">

    <div v-show="!editing">
      <div class="pull-right">
        <span v-if="!isStaff(currentUser) && isProcessing(query)">
          <query-status-labels :query="query" />
        </span>

        <div style="width: 100px; display: inline-block; text-align: right;">
          <i v-if="isStaff(currentUser) || (isStaffOrOwner && isKysely)" @click="editQuery" class="fa fa-pencil fa-lg" aria-hidden="true" style="cursor: pointer"></i>
          &nbsp;&nbsp;
          <i v-if="isStaffOrOwner" @click="confirmDelete" class="fa fa-trash fa-lg" aria-hidden="true" style="cursor: pointer"></i>
        </div>
      </div>

      <query-details :query="query" :current-user="currentUser" />

    </div>


    <div v-show="editing">
      <query-editor 
        :key="query.id" 
        :query="query"
        :current-user="currentUser"
        :response-templates="responseTemplates"
        @reload-queries="reloadQueries"
      />
    </div>

  </div>
 </template>

<script>
import { userMixin } from '@/mixins/userMixin.js'
import QueryDetails from './QueryDetails.vue'
import QueryStatusLabels from './QueryStatusLabels.vue'

export default {
  components: { 
    QueryDetails,
    QueryStatusLabels,
  },

  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
    currentUser: Object,
    responseTemplates: Array,
  },

  data() {
    return {
      editing: false,
    }
  },

  computed: {
    isStaffOrOwner() {
      return this.isStaff(this.currentUser) || (this.query.user_id == this.currentUser.id)
    },

    isKysely() {
      return this.query.query_type == 'kysymys_huomautus'
    },
  },

  methods: {
    editQuery() {
      this.editing = true
    },

    isProcessing(query) {
      return ['processing', 'waiting', 'in_virtual_list', 'checking_availability'].includes(query.status)
    },

    reloadQueries() {
      this.editing = false
      this.$emit('reload-queries')
    },

    confirmDelete() {
      const self = this

      bootbox.confirm("Oletko varma että haluat tuhota tämän?", function(result){
        if (result) {
          self.deleteQuery()
        }
      })
    },

    deleteQuery() {
      axios.delete(`/kysely/${this.query.id}`)
      .then((response) => {
        console.log(response)

        this.reloadQueries()
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        //
      });
    },

  },

}
</script>
